module.exports = __webpack_public_path__ + "img/ButtonOne.e344efa2.svg";